module.exports = __webpack_public_path__ + "static/media/Bootcamp-Sostenibilidad.e37bc9c7.mp4";